import { Button, Input, Radio, Select, Switch } from "antd"
import { t } from "~/languages/i18n"
import { useState } from "react"

interface ContentHomePageProps {
  title: string
  url: string
  onRemove: () => void
  onCancel: () => void
  onUpdate: (newTitle: string, newUrl: string) => void
}

export const ContentHomePage = ({ title, url, onRemove, onCancel, onUpdate }: ContentHomePageProps) => {
  const [localTitle, setLocalTitle] = useState(title)
  const [localUrl, setLocalUrl] = useState(url)

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value
    setLocalTitle(newTitle)
    onUpdate(newTitle, localUrl)
  }

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newUrl = e.target.value
    setLocalUrl(newUrl)
    onUpdate(localTitle, newUrl)
  }

  return (
    <div className="p-4">
      <span className=" text-lg mb-4">{t("URL")}</span>
      <Input className="mb-4" value={localUrl} onChange={handleUrlChange} />
      <span className="font-bold text-lg mb-4">{t("Navigation Label")}</span>
      <Input className="mb-4" value={localTitle} onChange={handleTitleChange} />
      <div className="flex">
        <Button type="link" className="text-red-500" onClick={onRemove}>
          {t("Remove")}
        </Button>
        <Button type="link" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </div>
    </div>
  )
}

const menuContent = {
  ContentHomePage,
}

export default menuContent
